import { render, staticRenderFns } from "./BimDemolitionBlockInfoModify.vue.html?vue&type=template&id=a1a47b9c&lang=html&external"
import script from "./BimDemolitionBlockInfoModify.vue.js?vue&type=script&lang=js&external"
export * from "./BimDemolitionBlockInfoModify.vue.js?vue&type=script&lang=js&external"
import style0 from "./BimDemolitionBlockInfoModify.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports